import React from 'react';
import PropTypes from 'prop-types';

import { SuiTextInput } from '@splashthat/sui';
import styled from 'styled-components';

import FormErrorMessage from '../../../errors/FormErrorMessage';

import { TICKET_EMAIL } from '../../../../constants/ticketTypes';

const EMAIL_LABEL = 'Email';

const TicketEmailInput = styled(SuiTextInput)`
    margin-bottom: 1.5rem;
`;

const TicketEmail = (props) => (
    <React.Fragment>
        <TicketEmailInput
            name={TICKET_EMAIL}
            label={EMAIL_LABEL}
            onChange={(e, value) => props.updateFormValue(TICKET_EMAIL, value)}
            variation={!props.touched && props.error ? 'error' : ''}
            placeholder={EMAIL_LABEL}
            autoComplete="off"
            fullWidth
            type="email"
        />
        {props.error && <FormErrorMessage nodeId={TICKET_EMAIL} errorType={props.error} label={EMAIL_LABEL} />}
    </React.Fragment>
);

TicketEmail.propTypes = {
    updateFormValue: PropTypes.func.isRequired,
    error: PropTypes.string,
    touched: PropTypes.bool,
};

TicketEmail.defaultProps = {
    error: null,
    touched: false,
};

export default TicketEmail;
